import { CommonModule, DatePipe, JsonPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { Approutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './auth.interceptor';
import { OrderSuccessComponent } from './views/common/components/order-success/order-success.component';
import { CustomNotificationsService } from './views/common/services/custom-notifications.service';
import { SignupWizardServerService } from './views/common/services/signup-wizard-server.service'; // Import the service

@NgModule({ declarations: [
        AppComponent,
        OrderSuccessComponent,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA], imports: [BrowserModule,
        RouterModule.forRoot(Approutes, {
            useHash: false,
        }),
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgxIntlTelInputModule,
        CommonModule,
        JsonPipe], providers: [
        provideClientHydration(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        // Add required services here
        SignupWizardServerService,
        CustomNotificationsService,
        DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
